export const IS_MAINTENANCE_SCHEDULED = false;
export const MAINTENANCE_MESSAGE =
  'We will be down for maintenance on May 29th at 8:30AM EST.';
// File and video upload limit in bytes
export const MAX_FILE_SIZE = 30000000;
// File and video upload limit in mebibyte (11MB)
export const MAX_RECORDING_FILE_SIZE = 11314135;
// Video recording time limit 6 minutes in seconds
export const VIDEO_TIME_LIMIT = 360;

// File upload recovery ROUTE
export const FILE_RECOVERY_SLUG = 'file-upload-recovery';
